import { salesGet, salesPatch, salesPost } from './salesTeam';
import type { CustomerRole } from './partnerCustomers';
import type { MediaView } from './partnerQuotes';
import type { SurveyAnswers } from './surveyText';
export { surveySummary, type SurveyAnswers, type SurveyChoice } from './surveyText';

/** Site survey mode (Api: lib/partnerSurveys.ts): what the partner's team found on site, before quoting. */
export interface SiteSurvey {
  id: string; created_by: string; partner_customer_id: string | null; partner_customer_site_id: string | null;
  customer: { business_name: string; contact_name: string; contact_email: string; contact_phone: string };
  site: { label: string; street: string; city: string; state: string; zip: string; country: string };
  customer_role: CustomerRole | null; answers: SurveyAnswers; notes: string; quote_id: string | null; job_id: string | null;
  archived: boolean; created_at: string; updated_at: string; photos?: number;
}
export type SurveyInput = Partial<Pick<SiteSurvey, 'partner_customer_id' | 'partner_customer_site_id' | 'customer' | 'site' | 'customer_role' | 'notes'>>
  & { answers?: Partial<SurveyAnswers>; archived?: boolean };
export const listSurveys = () => salesGet<SiteSurvey[]>('admin/partner-surveys');
export const getSurvey = (id: string) => salesGet<{ survey: SiteSurvey; photos: MediaView[] }>(`admin/partner-surveys/${id}`);
export const createSurvey = (body: SurveyInput) => salesPost<SiteSurvey>('admin/partner-surveys', body);
export const updateSurvey = (id: string, body: SurveyInput) => salesPatch<SiteSurvey>(`admin/partner-surveys/${id}`, body);
